import reduceReducers from 'reduce-reducers'

import changeStatusReducer from './changeStatus'
import fetchReducer from './fetch'
import removeReducer from './remove'
import saveReducer from './save'

export default reduceReducers(changeStatusReducer, fetchReducer, removeReducer, saveReducer)
